import React from 'react';
import styled from 'styled-components';
import Colors from '../../assets/styles/Colors'
import Responsive from '../../assets/config/Responsive';
import EnvelopeClosedIcon from '../../assets/icons/JSX/EnvelopeClosedIcon';
import TrashIcon from '../../assets/icons/JSX/TrashIcon';
const NotificationDetail = () => {
  return (
    <Wrapper>
      <TopSection>
      <Info>
        <InfoItem>From: Frani support</InfoItem>
        <Date>23 Oct 2022</Date>
      </Info>
      <IconsWrapper>
                <Btn>
                    <EnvelopeClosedIcon/>
                </Btn>
                <Btn>
                    <TrashIcon/>
                </Btn>
       </IconsWrapper>   
      </TopSection>
      <NotificationsText>Notifications</NotificationsText>

      <NotificationStyle>
        <LetterName>Lorem Ipsum is dummy text</LetterName>
        <LetterContent>
            Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.
        </LetterContent>
      </NotificationStyle>
    </Wrapper>
  )
}
// 
// 
const NotificationStyle = styled.div`
  border-radius: 10px;
  padding: 45px 70px 55px 70px;
  -webkit-box-shadow: 0px 0px 15px 3px #88888811; 
  box-shadow: 0px 0px 15px 3px #88888811; 
  background-color: ${Colors.white};
  border-radius: 8px;
  ${Responsive.mobile}{
    padding: 35px 30px 55px 30px;
  }
`;
const LetterName = styled.div`
  color: ${Colors.primaryBlack};
  font-size: 21px;
  margin-bottom: 20px;
  ${Responsive.mobile}{
    font-size: 17px;
  }
`;
const LetterContent = styled.div`
  color: ${Colors.primaryGrey};
  font-size: 14px;
  ${Responsive.mobile}{
    font-size: 17px;
  }
`;
const Btn = styled.button`
    padding: 15px;
    display: flex;
    border: 1px solid ${Colors.secondaryBlack};
    border-radius: 6px;
    margin-right: 10px;
    background-color: ${Colors.backgroundGrey};
`;
const Wrapper = styled.div`
   margin-top: 20px;
`;
const NotificationsText = styled.div`
    display: none;
    ${Responsive.mobile}{
        display: block;
        align-items: flex-start;
        margin-top: -20px;
        margin-bottom: 25px;
        font-size: 22px;
    }
`;
const Info = styled.div`
    display: block;
    align-items: flex-start;
    ${Responsive.mobile}{
        margin-bottom: 20px;
    }
`;
const InfoItem = styled.div`
    font-size: 20px;
    font-weight: 700px;
    margin-top: auto;
    margin-bottom: auto;
    color: ${Colors.primaryBlack};
`;
const Date = styled.div`
    font-size: 15px;
    font-weight: 700px;
    margin-top: 5px;
    color: ${Colors.primaryGrey};
`;
const IconsWrapper = styled.div`
    display: flex;
    margin-left: auto;
    margin-right: 0px;
`;
const TopSection = styled.div`
    border-radius: 10px;
    height: 50px;
    margin-bottom: 30px;
    display: flex;
    ${Responsive.mobile}{
        display: none;
    }
`;
export default NotificationDetail